interface IconProps {
  color?: string;
}

const SearchIcon = ({ color = "#001E96" }: IconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3333 15.5L9.08333 10.25C8.66667 10.5833 8.1875 10.8472 7.64583 11.0417C7.10417 11.2361 6.52778 11.3333 5.91667 11.3333C4.40278 11.3333 3.12167 10.8089 2.07333 9.76C1.025 8.71111 0.500556 7.43 0.5 5.91667C0.499445 4.40333 1.02389 3.12222 2.07333 2.07333C3.12278 1.02444 4.40389 0.5 5.91667 0.5C7.42944 0.5 8.71083 1.02444 9.76083 2.07333C10.8108 3.12222 11.335 4.40333 11.3333 5.91667C11.3333 6.52778 11.2361 7.10417 11.0417 7.64583C10.8472 8.1875 10.5833 8.66667 10.25 9.08333L15.5 14.3333L14.3333 15.5ZM5.91667 9.66667C6.95833 9.66667 7.84389 9.30222 8.57333 8.57333C9.30278 7.84444 9.66722 6.95889 9.66667 5.91667C9.66611 4.87444 9.30167 3.98917 8.57333 3.26083C7.845 2.5325 6.95944 2.16778 5.91667 2.16667C4.87389 2.16556 3.98861 2.53028 3.26083 3.26083C2.53306 3.99139 2.16833 4.87667 2.16667 5.91667C2.165 6.95667 2.52972 7.84222 3.26083 8.57333C3.99195 9.30444 4.87722 9.66889 5.91667 9.66667Z"
        fill={color}
        fillOpacity="0.7"
      />
    </svg>
  );
};
export default SearchIcon;
